<template>
    <div style="background-color: white;box-sizing:unset;min-width:1600px">
        <headers></headers>
        <!-- 中间内容区域 -->
         <!-- 中文版 -->
        <div v-if="langluageType != 'en'" class="window_con" style="box-sizing:unset">
            <div class="window_banner">
                <img src="../assets/propaganda/articlework.jpg" class="window_banner_img">
                <div class="banner_text">
                    <img src="../assets/propaganda/work_logo.svg" class="banner_text_img">
                    <h1>面向专业主场服务企业</h1>
                    <p>展会主场业务全流程一体化实时在线云管理系统</p>
                    <ul class="banner_ul">
                        <li data-type="Work主场云" data-href="/web/user/login" id="ljsy"><a href="javascript:;">立&nbsp;即&nbsp;试&nbsp;用</a></li>
                    </ul>
                </div>
            </div>
            <div class="article" style="box-sizing:unset">
                <div class="tit_con">
                    <h1>主场云的解决方案</h1>
                    <p>解决传统模式中，资料审核效率低、人员接触频次高、动态信息传递慢、展装申报体验差、服务项目收费乱、现场执行管理难等问题</p>
                </div>
                <div class="article_con clearfix">
                    <div class="article_con_module">
                        <h2>提高业务敏捷性</h2>
                        <ul>
                            <li><i class="square" style="vertical-align:none;"></i>行业特定的功能和卓越实践</li>
                            <li><i class="square"></i>基于50场专业展会积累的流程</li>
                            <li><i class="square"></i>实时嵌入式BI统计分析</li>
                            <li><i class="square"></i>覆盖主场全过程的自动化流程</li>
                        </ul>
                    </div>
                    <div class="article_con_module">
                        <h2>获得稳定性和控制力</h2>
                        <ul>
                            <li><i class="square"></i>腾讯云部署确保数据安全</li>
                            <li><i class="square"></i>集成的商业智能快速把握新机遇</li>
                            <li><i class="square"></i>项目创建、规则设置，简化流程</li>
                            <li><i class="square"></i>注册即用，角色管理，部署速度快</li>
                        </ul>
                    </div>
                    <div class="article_con_module">
                        <h2>持续降本可持续性</h2>
                        <ul>
                            <li><i class="square"></i>资料设置、价格设置、图纸审核灵活</li>
                            <li><i class="square"></i>自主申报、信息交流提高敏捷性</li>
                            <li><i class="square"></i>自定义现场管理、痕迹跟踪高效运营</li>
                            <li><i class="square"></i>支持实时分析，帮助提高利润和效率</li>
                        </ul>
                    </div>
                </div>
                <div class="main-info" style="box-sizing:unset">
                    <div class="main-bd" style="box-sizing:unset">
                        <!-- <div class="fa-items qj">
                            <div class="items-title qijianban">
                                <h3>基础版</h3>
                                <p>BASIC EDITION</p>
                            </div>
                            <div class="use-title" style="background-color: #ED2B33;">
                                <h3 style="color: #fff;font-size: 40px;">免费</h3>
                            </div>
                            <div class="items-bd">
                                <div class="items-bd-intro">5个固定角色</div>
                                <div class="items-bd-intro">基础主场功能</div>
                                <div class="items-bd-intro">报馆功能</div>
                                <div class="items-bd-intro">部分财务功能</div>
                                <div class="items-bd-intro">通讯功能</div>
                                <div class="items-bd-intro">500套云数据存储</div>
                            </div>
                        </div> -->
                        <div class="fa-items gj">
                            <div class="items-title gaojiban">
                                <h3>专业版</h3>
                                <p>高效管理、专业形象、有效协同</p>
                            </div>
                            <div class="use-title">
                                <div>民营小微优惠价</div>
                                <h4>¥16800/<span>年</span></h4>
                                <div>市场价50000元/年</div>
                            </div>
                            <div class="items-bd">
                                <div class="items-bd-intro">20个自定义角色</div>
                                <div class="items-bd-intro">定制化域名</div>
                                <div class="items-bd-intro">在线审核图纸订单</div>
                                <div class="items-bd-intro">报馆申报流程设置</div>
                                <div class="items-bd-intro">项目设置一键调取</div>
                                <div class="items-bd-intro">商品加收规则设置</div>
                                <div class="items-bd-intro">4核8GB 4MPBS</div>
                                <div class="items-bd-intro">2000套云数据存储</div>

                            </div>
                            <div class="rebate">
                                <p>60%</p>
                                <span>用户选择</span>
                            </div>
                        </div>
                        <div class="fa-items qj">
                            <div class="items-title qijianban">
                                <h3>旗舰版</h3>
                                <p>融合管理、灵活开放、便捷协同</p>
                            </div>
                            <div class="use-title">
                                <div>民营小微优惠价</div>
                                <h4>¥26800/<span>年</span></h4>
                                <div>市场价80000元/年</div>
                            </div>
                            <div class="items-bd">
                                <div class="items-bd-intro">30个自定义角色</div>
                                <div class="items-bd-intro">小程序现场下单</div>
                                <div class="items-bd-intro">一站式后台管理</div>
                                <div class="items-bd-intro">证件实名认证</div>
                                <div class="items-bd-intro">小程序实时公告</div>
                                <div class="items-bd-intro">8核16GB 8MPBS</div>
                                <div class="items-bd-intro">3500套云数据存储</div>
                                <div class="items-bd-intro">包含所有专业版功能</div>
                            </div>
                        </div>
                        <div class="fa-items ydqj">
                            <div class="items-title yidongqijianban">
                                <h3>旗舰版PLUS</h3>
                                <p>全面管理、价值提升、深度协同</p>
                            </div>
                            <div class="use-title">
                                <div>民营小微优惠价</div>
                                <h4>¥39800/<span>年</span></h4>
                                <div>市场价1188000元/年</div>
                            </div>
                            <div class="items-bd">
                                <div class="items-bd-intro">50个自定义角色</div>
                                <div class="items-bd-intro">小程序巡查管理</div>
                                <div class="items-bd-intro">小程序资料查询</div>
                                <div class="items-bd-intro">小程序整改记录</div>
                                <div class="items-bd-intro">小程序展位验收</div>
                                <div class="items-bd-intro">8核32GB 8MPBS</div>
                                <div class="items-bd-intro">5000套云数据存储</div>
                                <div class="items-bd-intro">包含所有旗舰版功能</div>
                            </div>
                        </div>					
                    </div>
                    <div style="background-color:#ED2B33; color:#fff; text-align:center; font-size: 14px; line-height:30px; margin-top:30px">
                        新用户首年系统年费享5折优惠 &emsp;&emsp;&emsp; 以上价格不包含短信和存储等硬性费用
                    </div>
                    <div class="foot-dber" style="margin-top: 50px">
                        <!-- <a href="/web/can-ping/ban-ban" class="detail-db-btn2">详细功能对比</a> -->
                        <el-link :underline="false" href="banben" class="detail-db-btn2">详细功能对比</el-link>
                    </div>
                </div>
            </div>
        </div>
        <!-- 英文版 -->
        <div v-else class="window_con" style="box-sizing:unset">
            <div class="window_banner">
                <img src="../assets/propaganda/articlework1.jpg" class="window_banner_img">
                <div class="banner_text">
                    <img src="../assets/propaganda/work_logo.svg" class="banner_text_img">
                    <h1>Online cloud system for official service provider</h1>
                    <!-- <p style="line-height: normal;margin-top: 18px;">An integrated real-time online cloud management system for the entire the entire</p>
                    <p style="line-height: normal;margin-bottom: 18px;">exhibition business process</p>
                    <ul class="banner_ul">
                        <li data-type="Work主场云" data-href="/web/user/login" id="ljsy"><a href="javascript:;">Try it now</a></li>
                    </ul> -->
                </div>
            </div>
            <div class="article" style="box-sizing:unset;width:1600px">
                <!-- <div class="tit_con">
                    <h1>Work Cloud Solution</h1>
                    <p>Solve the problems in the traditional model, such as low efficiency of data review, high frequency of personnel contact, slow dynamic information transmission, poor exhibition application experience, chaotic service item charges, and difficult on-site execution management.</p>
                </div> -->
                <div class="article_con clearfix" style="margin-top:70px;margin-bottom: 140px;">
                    <div class="article_con_module" style="width:31%">
                        <h2>Improve business agility</h2>
                        <ul>
                            <li><i class="square" style="vertical-align:none;"></i>Industry-specific capabilities and best practices</li>
                            <li><i class="square"></i>Process based on 50 professional exhibitions</li>
                            <li><i class="square"></i>Real-time embedded BI statistical analysis</li>
                            <li><i class="square"></i>Automated process covering the entire home field process</li>
                        </ul>
                    </div>
                    <div class="article_con_module"  style="width:34%">
                        <h2>Gain stability and control</h2>
                        <ul>
                            <li><i class="square"></i>Tencent Cloud deployment ensures data security</li>
                            <li><i class="square"></i>Integrated business intelligence to quickly seize new opportunities</li>
                            <li><i class="square"></i>Project creation, rule setting, and simplified processes</li>
                            <li><i class="square"></i>Register and use, role management, fast deployment</li>
                        </ul>
                    </div>
                    <div class="article_con_module"  style="width:35%">
                        <h2>Continuous cost reduction and sustainability</h2>
                        <ul>
                            <li><i class="square"></i>Flexible data setting, price setting, and drawing review</li>
                            <li><i class="square"></i>Self-declaration and information exchange improve agility</li>
                            <li><i class="square"></i>Customized on-site management、trace tracking for efficient operation</li>
                            <li><i class="square"></i>Supports real-time analysis to help improve profits and efficiency</li>
                        </ul>
                    </div>
                </div>
                <!-- <div class="main-info" style="box-sizing:unset">
                    <div class="main-bd" style="box-sizing:unset;margin-top:50px;">
                        <div class="fa-items gj">
                            <div class="items-title gaojiban">
                                <h3 style="margin-top: 10px;">PROFESSIONAL EDITION</h3>
                                <p>¥50000/<span>year</span></p>
                            </div>
                            <div class="use-title" style="height: 110px;">
                                <div>Discounts for private small and micro enterprises to</div>
                                <h3>¥16800<span>/year</span></h3>
                            </div>
                            <div class="items-bd">
                                <div class="items-bd-intro">15 custom characters</div>
                                <div class="items-bd-intro">Announcement</div>
                                <div class="items-bd-intro">Customized domain name</div>
                                <div class="items-bd-intro">Independent login page</div>
                                <div class="items-bd-intro">2 cores 4GB 4MPBS</div>
                                <div class="items-bd-intro">1,000 sets of cloud data storage</div>
                                <div class="items-bd-intro">Contains all basic features</div>

                            </div>
                            <div class="rebate2">
                                <p>60% User Selection</p>
                            </div>
                        </div>
                        <div class="fa-items qj">
                            <div class="items-title qijianban">
                                <h3 style="margin-top: 10px;">ULTIMATE EDITION</h3>
                                <p>¥80000/<span>year</span></p>
                            </div>
                            <div class="use-title" style="height: 110px;">
                                <div>Discounts for private small and micro enterprises to</div>
                                <h3>¥26800<span>/year</span></h3>
                            </div>
                            <div class="items-bd">
                                <div class="items-bd-intro">30 custom characters</div>
                                <div class="items-bd-intro">Customization of some data dashboards</div>
                                <div class="items-bd-intro">Mobile on-site ordering</div>
                                <div class="items-bd-intro">Mobile real-name authentication</div>
                                <div class="items-bd-intro">4 cores 8GB 8MPBS</div>
                                <div class="items-bd-intro">2000 sets of cloud data storage</div>
                                <div class="items-bd-intro">Includes all Pro features</div>
                            </div>
                        </div>
                        <div class="fa-items ydqj">
                            <div class="items-title yidongqijianban">
                                <h3 style="margin-top: 10px;">ULTIMATE EDITION PLUS</h3>
                                <p>¥118000/<span>year</span></p>
                            </div>
                            <div class="use-title" style="height: 110px;">
                                <div>Discounts for private small and micro enterprises to</div>
                                <h3>¥39800<span>/year</span></h3>
                            </div>
                            <div class="items-bd">
                                <div class="items-bd-intro">50 custom characters</div>
                                <div class="items-bd-intro">Electronic Invoice</div>
                                <div class="items-bd-intro">Mobile site management</div>
                                <div class="items-bd-intro">Mobile booth acceptance</div>
                                <div class="items-bd-intro">8 cores 16GB 16MPBS</div>
                                <div class="items-bd-intro">5,000 sets of cloud data storage</div>
                                <div class="items-bd-intro">Includes all Ultimate features</div>
                            </div>
                        </div>					
                    </div>
                    <div style="background-color:#ED2B33; color:#fff; text-align:center; font-size: 14px; line-height:45px; margin-top:30px">
                        New users enjoy a 50% discount on the annual system fee for the first year,The above prices do not include fixed fees such as SMS and storage

                    </div>
                    <div class="foot-dber" style="margin-top: 50px">
                        <el-link :underline="false" href="banben" class="detail-db-btn2" style="background-color:#ED2B33;">Detailed feature comparison</el-link>
                    </div>
                </div> -->
            </div>
        </div>
        <footers></footers>
        <contact></contact>
        <dialog1 data-type="Work主场云"></dialog1>
    </div>
</template>
<script>
  import headers from '@/components/Header';
  import footers from '@/components/Footer';
  import contact from '@/components/contact';
  import dialog1 from '@/components/dialog';
  import $ from 'jquery';
            // 立即试用 
            console.log("123",);
            
            
export default {
    components: {
      headers,
      footers,
      contact,
      dialog1
    },
    data(){
        return {
            aaaa:true,
            regex:'/^1\d{10}$/',
            langluageType:sessionStorage.getItem('langluageType')||'ch'
        }
    },
}
</script>
<style>
.main-info .main-bd .fa-items .rebate2{
    position: absolute;
    top: -21px;
    left: 50%;
    transform: translateX(-50%);
    width: 278px;
    height: 40px;
    /* padding: 2px 0 30px; */
    box-sizing: border-box;
    color: #fff;
    text-align: center;
    background-color: #d0021b;
    line-height: 40px;
    background: url(../assets/image/rebate.svg) no-repeat center;
    background-size: 100% 100%;
}
.main-info .main-bd .fa-items .rebate2>p{
    font-size: 16px;
    margin-bottom: 2px;
}
.main-info .main-bd .fa-items .rebate2>span{
    /* font-size: 12px; */
    font-weight: 100;
}
/* .main-info .main-bd .fa-items .rebate2::after{
    content: '';
    display: block;
    position: absolute;
    bottom: -12px;
    left: 105%;
    width: 40px;
    height: 64px;
    box-sizing: border-box;
    text-align: center;
    background: url(../assets/image/rebate.png) no-repeat center;
    background-size: 100% 100%;
    transform: rotate(-90deg);
} */
.main-info .main-bd .fa-items .rebate2::before{
    /* content: '';
    display: block;
    position: absolute;
    bottom: -12px;
    left: -32%;
    width: 40px;
    height: 64px;
    box-sizing: border-box;
    text-align: center;
    background: url(../assets/image/rebate.svg) no-repeat center;
    background-size: 100% 100%; */
}

</style>



// WEBPACK FOOTER //
// src/page/articlework.vue